import React from 'react'
import Tooltip from "../tooltip/Tooltip";

const SelectableGoal = ({ size, goal, changeActiveState, isMainGoal, showHelper }) => {

    return(
        <div className={ isMainGoal ? 'flex-row items-center w400' : ''}>
            <img
                id={goal.name}
                className={`goal-image ${goal.active? '' : 'grey-overlay'}`}
                src={require(`../../../images/agendaIcons/${goal.srcImg}`)}
                alt="kuva"
                height={size}
                onClick={() =>  changeActiveState
                    ? goal.canModify && changeActiveState(goal)
                    : undefined}
            />

            {goal.name &&
            <div className="margin-left">
                <p className="p">{goal.name}</p>
                {showHelper && <Tooltip textKey={`sit.commitmentCreation.maingoal.infotext.${ goal.categoryId }`}/>}
            </div>}
        </div>
    )
}

export default SelectableGoal




// WEBPACK FOOTER //
// ./src/components/materialCommitment/agenda/SelectableGoal.jsx